
export function validate_numbers(theData){

    if( $.isNumeric(theData) ) return true;

    return "txt150";

};